import { observable } from 'mobx';

import { SettingsService } from '../../services/SettingsService';

export interface INotification {
    title: string;
    text: string;
    type: string;
    link: string | null;
    redirect: boolean;
}

export class UserNotificationStore {
    public static instance: UserNotificationStore;
    @observable
    public notifications: Array<INotification> = new Array<INotification>();

    public static getInstance() {
        if (UserNotificationStore.instance == undefined) {
            UserNotificationStore.instance = new UserNotificationStore();
        }

        return UserNotificationStore.instance;
    }

    public refreshNotifications() {
        const newNotifications = new Array<INotification>();

        if (SettingsService.getInstance().nameIsIncomplete()) {
            newNotifications.push({
                title: 'Your personal data',
                text: 'Please enter your name and surname.',
                type: 'alert',
                link: '/app/settings',
                redirect: false
            });
        }

        // if (!SettingsService.getInstance().emailIsVerified()) {
        //     newNotifications.push({
        //         title: 'Verify your email',
        //         text: 'Your account has not yet verified email.',
        //         type: 'alert',
        //         link: null,
        //         redirect: false
        //     });
        // }

        this.notifications = observable.shallowArray(newNotifications);
    }

    private constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/UserNotifications/UserNotificationStore.ts